const n = (c, l) => {
  const r = l(c);
  if (typeof r != "object" || r === null)
    return r;
  const t = Array.isArray(r) ? [] : {};
  for (const [s, e] of Object.entries(r))
    Array.isArray(e) ? t[s] = e.map(
      (o) => typeof o == "object" && o !== null ? n(o, l) : o
    ) : typeof e == "object" && e !== null ? t[s] = n(e, l) : t[s] = e;
  return t;
};
export {
  n as traverse
};
//# sourceMappingURL=traverse.js.map
